import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { PredefinedRiskAreaViewModel } from "../riskAreas/RiskAreas.types";

export const predefinedRiskAreasUrl = "/risk-areas/predefined";

export function usePredefinedRiskAreas() {
    const { isLoading, data } = useDotLegalQuery<Array<PredefinedRiskAreaViewModel>>(predefinedRiskAreasUrl);

    return {
        isLoading,
        predefinedRiskAreas: data ?? [],
    };
}
